<template>
  <v-card>
    <v-toolbar
      class="white--text"
      color="indigo"
      style="position: sticky; top: 0px; z-index: 1"
    >
      <v-toolbar-title dense> Dichiarazione Fermi </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone salva e continua -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="mr-5"
            @click="clickSalva"
            large
          >
            <v-icon color="success" style="font-size: 40px">
              mdi-floppy
            </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di indietro senza salvare -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn large v-bind="attrs" v-on="on" @click="clickIndietro">
            <v-icon color="error" style="font-size: 40px"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>

    <!-- Corpo della card -->
    <v-card-text>
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="6" align="right" class="px-5">
            <span class="label" style="color: #3399ff">
              <b>Causali di Fermo</b>
            </span>
          </v-col>
          <v-col cols="6" align="left" class="px-5">
            <span class="label" style="color: #3399ff">
              <b>Minuti</b>
            </span>
          </v-col>
        </v-row>
        <v-row
          align="center"
          justify="center"
          :key="causale.id_causale"
          v-for="causale in causali"
        >
          <v-col cols="6" align="right" class="px-5">
            <span style="color: black; font-size: 18px">
              <b>{{ causale.des }}</b>
            </span>
          </v-col>
          <v-col cols="6" align="left" class="px-5">
            <v-text-field
              background-color="#ffffff"
              dense
              hide-details
              label=""
              outlined
              style="
                border-radius: 0px;
                display: inline-block;
                font-size: 20px;
                max-width: 100px;
              "
              type="number"
              v-model="causale.minuti"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Fermo {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "des", default_val: "" },
      { nome: "id_causale", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_causale", default_val: -1 },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "minuti", default_val: 0 },
      { nome: "tipo", default_val: null },
      { nome: "tipo_causale", default_val: "FERMO" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "RegistraFermi",
  components: {
    SnackbarQV,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    work_order_sel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
      causali: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      async handler() {
        if (this.visible === true) {
          await this.getCausali();
        }
      },
    },
  },
  methods: {
    clickIndietro() {
      this.$emit("click_indietro");
    },
    clickSalva() {
      const arr_tmp = Array.from(this.causali.filter((e) => e.minuti > 0));
      arr_tmp.forEach((elem) => {
        elem.id_personale = localStorage.id_utente;
      });

      if (arr_tmp.length > 0) {
        /* Se ci sono pezzi da scartare faccio una chiamata
         * indipendente che salva i pezzi da scartare. */
        let setCausaliCommessa = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setcausalicommessa",
            token: localStorage.user_token,
            tabella: arr_tmp,
          },
        };

        this.$store
          .dispatch("api", setCausaliCommessa)
          .then((res) => {
            if (res.status === 200) {
                this.$emit("click_salva");
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore nella comunicazione col server, non è stato possibile salvare i dati."
              );
            }
          })
          .catch((e) => {
            console.error(e);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          });
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare dei fermi per salvare."
        );
      }
    },
    getCausali() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.user_token,
          tipo: "FASE_causali",
          filter:
            "(val_int IS NULL OR val_int = " +
            this.work_order_sel.id_fase +
            ") AND validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.causali = new Array();
            if (res.data) {
              res.data.forEach((e) => {
                const causale_tmp = new Fermo();
                causale_tmp.des = e.des;
                causale_tmp.id_causale = e.id_tabella;
                causale_tmp.id_commessa = this.work_order_sel.id_commessa;
                causale_tmp.id_commessa_dettaglio =
                  this.work_order_sel.id_commessa_dettaglio;
                causale_tmp.id_commessa_tempi =
                  this.work_order_sel.id_commessa_tempi;
                causale_tmp.tipo = null;
                this.causali.push(Object.assign({}, causale_tmp));
              });
            }

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          return false;
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>